<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KA3PQH/tc-custom/FC-9781528950541.jpg?1684515191996?1719576272029" alt="This image is the cover for the book Finish-in-Four"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Finish-in-Four
      </h1>
      <p class="bookDescription body article font2">
        <p>Higher education is in a state of crisis!</p><p>College budgets are becoming a challenge to balance. Expenses are continually increasing in an environment of declining enrollments, endowments, and government support. The stop-gap solution for decades was to increase tuition—this is no longer viable.</p><p>Students, parents, donors, and government agencies are scrutinizing the cost and return on investment of a college education. Colleges are under pressure for their underperformance of only graduating 40% of students on time while the national student debt is skyrocketing.</p><p>Addressing the issue of approximately 2 million students that start college annually and drop out provides colleges with an opportunity to turn the crisis around. Finish in Four introduces a model that provides an approach for developing strategic solutions in ten key areas to improve on-time graduation rates and reduce student debt. This will result in improved fiscal stability for America’s struggling colleges.</p><p>A must read for all college stakeholders and students selecting a college.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeff Marsee, Ph.D.
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0mm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style="font-size:13px;">Jeff Marsee, Ph.D., is a higher education consultant, trainer, presenter, former college president and Fulbright Scholar. His extensive career has included working with and at non-profit and for-profit (two and four-year) colleges; focusing on changing institutional models to improving student retention and graduation rates. The cumulation of his experiences, observations and research has been the development of a strategic planning (C-PAM) model that helps colleges assess and improve their performance in ten critical student success areas.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78b54abe